
// Module
import routes from './routes';

export default angular.module( 'app.forgotPassword.module',
    [] )
    .config(routes)
    .name;



/** WEBPACK FOOTER **
 ** ./src/guest/forgotPassword/index.js
 **/